import {getNoteDocList, getNoteList, updateNoteDoc} from "@model/note";
import {getDoc} from "@model/doc";
import {
    BASE64_IMAGE_TRANSPARENT, DEFAULT_TAG_BACKGROUND_COLOR,
    KEY_CARD_ORDER_BY, KEY_FILE_DIR,
    KEY_UPGRADE_DATA_20240717,
    KEY_UPGRADE_DATA_20241030, MAX_HISTORY_COUNT
} from "@/Const";
import {getCardById, updateCard} from "@model/card";
import {
    generateUUID2,
    getBase64ImageSize,
    getNoteDocThumbHtml,
    getPdfImageThumb, getVideoImageThumb, getYoutubeThumbUrl,
    isAudioFileElement,
    isFileElement,
    isFileVideoElement, isNoteElement,
    isPdfFileElement, isString, isSvg, isYoutubeUrl, recursionMindmapData
} from "@/utils";
import {isMindmapElement} from "../@excalidraw/packages/excalidraw/element/typeChecks";
import {getEmbedLink} from "../@excalidraw/packages/excalidraw/element/embeddable";
import {toValidURL} from "../@excalidraw/packages/excalidraw/data/url";
import {dbGetHighlight, dbHighlightCount, highlightList, updateHighlight} from "@model/highlight";
import {
    clearProjectHistoryDoc,
    deleteProjectHistory,
    projectAllHistoryList,
    projectHistoryDoc,
    projectHistoryList,
    updateProjectHistoryDoc
} from "@model/projectHistory";
import {ipcInvoke} from "@/common/ipc";
import {loopAllNode, loopAllNodeAsync} from "@/TreeUtils";
import {batchUpdateBoard} from "@model/board";
import {batchUpdateTags, updateTag} from "@model/tag";
import {batchUpdateProperties} from "@model/Property";
import {updateView} from "@model/view";
import {batchUpdateTranscripts} from "@model/transcript";

export async function updateUpGradeData(callback:any){
    return updateCardToWhole(callback);
}
/**
 * 20240717 v1.3.0->v1.4.0
 * 更新所有项目的card 到 公共部分.
 */
async function updateCardToWhole(callback:any){
    // if (localStorage.getItem(KEY_UPGRADE_DATA_20240717))return;

    return new Promise((resolve, reject) => {
        getNoteList().then(async (arrayDatas:any)=>{
            for (let i=0;i<arrayDatas.length;i++){
                const item = arrayDatas[i];
                const data = await getDoc(item.id);
                if (!data)continue;
                let jsonData;
                if (isString(data.doc)){
                    jsonData = JSON.parse(data.doc);
                }else{
                    jsonData = data.doc;
                }

                let hasUpdateNote = false;
                //全部保存到所有项目的公共部分....
                for (let k=0;k<jsonData.notes?.length;k++){
                    hasUpdateNote = true;
                    const item = jsonData.notes[k];
                    updateElementNoteId(item,jsonData);
                    await updateCard({id:item.key,name:item.title,type:'card',thumbHtml:getNoteDocThumbHtml(item.noteDataDoc),doc:item.noteDataDoc});
                }

                //保存元素上的文件
                await loopAllNodeAsync(jsonData.canvas,async (canvas:any)=>{
                    if (canvas.drawJson?.elements){
                        for (let j = 0; j < canvas.drawJson.elements.length; j++) {
                            const element = canvas.drawJson.elements[j];
                            if (isFileElement(element)){
                                element.customData.generationData.id = element.id;
                                let item:any = {
                                    id:element.id,
                                    name:element.customData?.generationData?.showName,
                                    fileName:element.customData?.generationData?.fileName
                                }
                                if (isPdfFileElement(element)){
                                    let szImgBase64:any = BASE64_IMAGE_TRANSPARENT;
                                    try{
                                        szImgBase64 = await getPdfImageThumb('localfile://'+element.customData?.generationData?.fileName);
                                    }catch (e){
                                        console.log('upgrade_pdf_:+'+e);
                                    }

                                    item.type = 'pdf';
                                    item.thumbImage = szImgBase64;
                                }else if (isAudioFileElement(element)){
                                    item.type = 'audio';
                                }else if (isFileVideoElement(element)){
                                    let szImgBase64:any = BASE64_IMAGE_TRANSPARENT;
                                    try{
                                        szImgBase64 = await getVideoImageThumb('localfile://'+element.customData?.generationData?.fileName);
                                    }catch (e) {
                                        console.log('upgrade_video_:+'+e);
                                    }

                                    item.type = 'video';
                                    item.thumbImage = szImgBase64;
                                }else{
                                    item.type = 'file';
                                }

                                await updateCard(item);
                            }
                        }
                    }
                })

                if (hasUpdateNote){
                    data.doc = JSON.stringify(jsonData);
                    await updateNoteDoc(data);
                }
                callback(i/arrayDatas.length)
            }

            localStorage.setItem(KEY_UPGRADE_DATA_20240717,Date.now()+'');
            resolve('ok');
        })
    })
}

/**
 * 分离一个page的数据到library
 * @param pageDatas
 */
export async function updateCanvasToLibrary (pageDatas:any,bNeedSave:boolean,callback:any,extra:any){
    let isSaveTags = extra?.isSaveTag;
    let arrayTags:any = [];//要保存的tag集合...

    let nIndex = 0;
    let nTotalCount = pageDatas.notes.length;
    loopAllNode(pageDatas.canvas,(node)=>{
        if (node.drawJson?.elements){
            nTotalCount += node.drawJson.elements.length;
        }
    })
    // for (let i=0;i<pageDatas.canvas.length;i++) {
    //     const canvas = pageDatas.canvas[i];
    //     nTotalCount += canvas.drawJson.elements.length;
    // }

    //导入的card,文件到库并且保存到数据库...
    for (let i=0;i<pageDatas.notes.length;i++){
        const note = pageDatas.notes[i];
        //更新元素上的引用ID
        updateElementNoteId(note,pageDatas);
        await updateCard({
            id:note.key,
            name:note.title,
            type:'card',
            doc:note.noteDataDoc
        })
        callback(nIndex++/nTotalCount);
    }
    //导入的librarys...
    if (pageDatas.librarys){
        for (let i=0;i<pageDatas.librarys.length;i++){
            const item = pageDatas.librarys[i];
            if (isSaveTags){
                if (item.tags){
                    arrayTags.push(...item.tags);
                }
            }else {
                //清空tag
                item.tags = [];
            }

            await updateCard(item);
        }
    }
    //处理pdf注记
    if (pageDatas.pdfAnnos){
        //保存到注记文件--注记文件会自动分离数据到库...
        for (let i=0;i<pageDatas.pdfAnnos.length;i++){
            const item = pageDatas.pdfAnnos[i];
            await ipcInvoke('save-annotations',{fileId:item.id,annotations:item.annotations})
        }
    }

    //处理视频注记
    if (pageDatas.videoHighlights){
        for (let i=0;i<pageDatas.videoHighlights.length;i++){
            const item = pageDatas.videoHighlights[i];
            //保存注记文件
            await updateHighlight(item);
            const library:any = await getCardById(item.libraryId || item.id);
            if (library?.type == 'audio')continue;
            for (let j=0;j<item.data?.length;j++){
                const videoAnno = item.data[j];
                const libraryItem = {
                    ...videoAnno,
                    name:library?.name || item.name,
                    libraryId:library?.id,
                    type:'videoAnno',
                }
                if (isSaveTags){
                    if (libraryItem.tags){
                        arrayTags.push(...libraryItem.tags);
                    }
                }else{
                    libraryItem.tags = [];
                }
                await updateCard(libraryItem);
            }
        }
    }

    //音频标注
    if (pageDatas.audioHighlights){
        for (let i=0;i<pageDatas.audioHighlights.length;i++){
            const item = pageDatas.audioHighlights[i];
            //保存注记文件
            await updateHighlight(item);
            const library:any = await getCardById(item.libraryId);
            for (let j=0;j<item.data?.length;j++){
                const videoAnno = item.data[j];
                const libraryItem = {
                    ...videoAnno,
                    name:library?.name || item.name,
                    libraryId:library?.id,
                    type:'audioAnno',
                }
                if (isSaveTags){
                    if (libraryItem.tags){
                        arrayTags.push(...libraryItem.tags);
                    }
                }else{
                    libraryItem.tags = [];
                }
                await updateCard(libraryItem);
            }
        }
    }

    //卡片标注
    if (pageDatas.cardHighlights){
        //只保存到库
        for (let i=0;i<pageDatas.cardHighlights.length;i++){
            const item = pageDatas.cardHighlights[i];
            if (isSaveTags){
                if (item.tags){
                    arrayTags.push(...item.tags);
                }
            }else{
                item.tags = [];
            }
            await updateCard(item);
        }
    }

    //board
    if (pageDatas.boards){
        pageDatas.boards.forEach(p=>{
            if (isSaveTags){
                if (p.tags){
                    arrayTags.push(...p.tags);
                }
            }else{
                p.tags = [];
            }
        })
        await batchUpdateBoard(pageDatas.boards);
    }

    //所有字幕
    if (pageDatas.transcripts){
        await batchUpdateTranscripts(pageDatas.transcripts);
    }

    //todo 卡片标注

    //文件
    await loopAllNodeAsync(pageDatas.canvas,async (canvas)=>{
        if (canvas.drawJson?.elements){
            for (let j=0;j<canvas.drawJson.elements.length;j++){
                const element = canvas.drawJson.elements[j];
                if (isFileElement(element)){
                    if (!element.customData.generationData.id){
                        element.customData.generationData.id = element.id;
                    }

                    let item:any = pageDatas.librarys?.find(p=>p.id == element.customData?.generationData?.id || p.id == element.id)

                    if (!item){
                        item = {
                            id:element.customData?.generationData?.id || element.id,
                            name:element.customData?.generationData?.showName,
                            fileName:element.customData?.generationData?.fileName
                        }
                    }

                    if (isPdfFileElement(element)){
                        let szImgBase64 = await getPdfImageThumb('localfile://'+element.customData?.generationData?.fileName);
                        item.type = 'pdf';
                        //保存base64到文件
                        let szFileName = item.id + '.png';
                        await ipcInvoke('write-base64-image-if-not-exist',{imgBase64:szImgBase64,fileName:szFileName})
                        item.thumbImage = 'localfile://'+szFileName;
                    }else if (isAudioFileElement(element)){
                        item.type = 'audio';
                    }else if (isFileVideoElement(element)){
                        let szImgBase64 = await getVideoImageThumb('localfile://'+element.customData?.generationData?.fileName);
                        item.type = 'video';

                        let szFileName = item.id + '.png';
                        await ipcInvoke('write-base64-image-if-not-exist',{imgBase64:szImgBase64,fileName:szFileName})
                        item.thumbImage = 'localfile://'+szFileName;
                    }else{
                        item.type = 'file';
                    }
                    item.tags = [];
                    await updateCard(item);
                }else if (isMindmapElement(element)){
                    await recursionMindmapData(element.data,async (data:any)=>{
                        if (data.extra){
                            if (data.extra.type == 'pdf'){
                                let item = {
                                    id:data.extra.id,
                                    name:data.extra.showName
                                }

                                item.type = 'pdf';
                                item.fileName = data.extra.fileName;
                                item.thumbImage = data.image;
                                await updateCard(item);
                            }
                        }
                    })
                }
                callback(nIndex++/nTotalCount);
            }
        }
    })

    //处理tags
    if (arrayTags.length > 0){
        const uniqueArr = [...new Set(arrayTags)];
        const arrayTaggs = [];
        for (let i=0;i<uniqueArr.length;i++){
            const szTagName = uniqueArr[i];
            const tag = pageDatas.tags?.find(p=>p.name == szTagName);
            arrayTaggs.push({
                id:tag?.id || generateUUID2(),
                groupId:'-1',
                name:szTagName,
                updateTime:Date.now(),
                createTime:Date.now(),
                backgroundColor:DEFAULT_TAG_BACKGROUND_COLOR
            })
            const propertyView = pageDatas.propertyViews?.find(p=>p.tagName == szTagName);
            if (propertyView){
                updateView(propertyView);
            }
        }
        batchUpdateTags(arrayTaggs);
    }
    if (extra?.isSaveProperty){
        //对于目前来的home来说，自定义的属性全部导入，不需要判断了.
        if (pageDatas.properties){
            batchUpdateProperties(pageDatas.properties);
        }
    }

    return 'ok';
}

/**
 * 更新元素上引用的note id
 * @param note
 */
function updateElementNoteId(note:any,pageDatas:any){
    loopAllNode(pageDatas.canvas,(canvas)=>{
        if (canvas.drawJson?.elements){
            for (let j=0;j<canvas.drawJson.elements.length;j++){
                const element = canvas.drawJson.elements[j];
                if (/*isNoteElement(element) &&*/ note.key == element.id){
                    element.customData.generationData.id = element.id;
                }
            }
        }
    })
}

/**
 * 升级原有的视频标注....
 */
export async function upgradeHighlight(){
    return new Promise(async (resolve, reject) => {
        const nHighlightCount = await dbHighlightCount();
        if (nHighlightCount == 0){
            getNoteList().then(async (arrayDatas:any)=>{
                for (let i=0;i<arrayDatas.length;i++){
                    const item = arrayDatas[i];
                    const data = await getDoc(item.id);
                    let jsonData = data.doc;
                    if (isString(data.doc)){
                        jsonData = JSON.parse(data.doc);
                    }

                    //保存元素上的文件
                    await loopAllNodeAsync(jsonData.canvas,async (canvas)=>{
                        if (canvas.drawJson?.elements){
                            for (let j = 0; j < canvas.drawJson.elements.length; j++) {
                                const element = canvas.drawJson.elements[j];
                                if (isFileVideoElement(element)){
                                    if (element.videoNotes){
                                        //保存到数据库
                                        const highlight:any = {
                                            id:element.customData.generationData.id,
                                            type:'video',
                                            libraryId:element.customData?.generationData?.id,
                                            name:element.customData?.generationData?.showName,
                                            fileName:element.customData?.generationData?.fileName,
                                            data:element.videoNotes
                                        }
                                        await updateHighlight(highlight);
                                    }
                                }else if (isYoutubeUrl(element.link)){
                                    const src = getEmbedLink(toValidURL(item.link || ""));
                                    //保存到数据库
                                    const highlight:any = {
                                        id:element.id,
                                        url:element.link,
                                        name:element.name || '',
                                        data:element.videoNotes,
                                        type:'youtube',
                                        thumbImage:getYoutubeThumbUrl(src?.videoId)
                                    }
                                    await updateHighlight(highlight);
                                }
                            }
                        }
                    })
                }

                localStorage.setItem(KEY_UPGRADE_DATA_20241030,Date.now()+'');
                resolve('ok');
            })
        }
    })

}

/**
 * 更新历史记录中的file.dataURL
 */
export async function upgradeProjectHistoryFile(){
    //整理相同的项目，每个保留10个
    const mapProjectHistory:any = {};
    projectAllHistoryList().then(async (res)=>{
        if (res){
            let bUpdate = false;
            for (let i=0;i<res.length;i++){
                bUpdate = false;
                const doc:any = await projectHistoryDoc(res[i].id);
                if (!doc)continue;

                let jsonData = doc;
                if (isString(doc)){
                    jsonData = JSON.parse(doc);
                }

                for (let j=0;j<jsonData.canvas.length;j++){
                    const canvas = jsonData.canvas[j];
                    if (canvas.drawJson.files){
                        const arrayFileValues:any = Object.values(canvas.drawJson.files);
                        for (let k=0;k<arrayFileValues.length;k++){
                            if (!isSvg(arrayFileValues[k].mimeType) && arrayFileValues[k].dataURL){
                                arrayFileValues[k].dataURL = '';
                                bUpdate = true;
                            }
                        }
                    }
                }
                let arrayProjects:any = mapProjectHistory[res[i].projectId];
                if (!arrayProjects){
                    arrayProjects = [];
                }
                arrayProjects.push(res[i]);
                mapProjectHistory[res[i].projectId] = arrayProjects;

                //不管有没有，直接更新成JSON存储
                await updateProjectHistoryDoc(res[i].id,(jsonData));
                //直接保存成文件

            }

            //整理map
            let arrayValues = Object.values(mapProjectHistory);
            for (let i=0;i<arrayValues.length;i++){
                const arrayProject:any = arrayValues[i];
                if (arrayProject.length > 10){
                    arrayProject.sort((a,b)=>{
                        return a.historyTime - b.historyTime;
                    })

                    const arrayForDelete = arrayProject.slice(0,arrayProject.length - 10);
                    for (let j=0;j<arrayForDelete.length;j++){
                        deleteProjectHistory(arrayForDelete[j].id)
                    }
                }
            }
        }
    })
}

/**
 * 直接存成文件
 */
export async function upgradeProjectHistoryToFile(){
    const mapProjectHistory:any = {};
    projectAllHistoryList().then(async (res)=>{
        if (res){
            let bUpdate = false;
            for (let i=0;i<res.length;i++){
                bUpdate = false;

                let arrayProjects:any = mapProjectHistory[res[i].projectId];
                if (!arrayProjects){
                    arrayProjects = [];
                }
                arrayProjects.push(res[i]);
                mapProjectHistory[res[i].projectId] = arrayProjects;
            }

            //整理map
            let arrayValues = Object.values(mapProjectHistory);
            for (let i=0;i<arrayValues.length;i++){
                const arrayProject:any = arrayValues[i];
                let arrayForSaved = null;
                if (arrayProject.length > MAX_HISTORY_COUNT){
                    arrayProject.sort((a,b)=>{
                        return a.historyTime - b.historyTime;
                    })

                    //
                    const arrayForDelete = arrayProject.slice(0,arrayProject.length - MAX_HISTORY_COUNT);
                    for (let j=0;j<arrayForDelete.length;j++){
                        deleteProjectHistory(arrayForDelete[j].id)
                    }
                    arrayForSaved = arrayProject.slice(arrayProject.length - MAX_HISTORY_COUNT,MAX_HISTORY_COUNT);
                    for (let j=0;j<arrayForSaved.length;j++){
                        const itemHistory = arrayForSaved[j];
                        const doc:any = await projectHistoryDoc(itemHistory.id);
                        if (!doc)continue;

                        let jsonData = doc;
                        if (isString(doc)){
                            jsonData = JSON.parse(doc);
                        }

                        loopAllNode(jsonData.canvas,(canvas:any)=>{
                            if (canvas.drawJson?.files){
                                const arrayFileValues:any = Object.values(canvas.drawJson.files);
                                for (let k=0;k<arrayFileValues.length;k++){
                                    if (!isSvg(arrayFileValues[k].mimeType) && arrayFileValues[k].dataURL){
                                        arrayFileValues[k].dataURL = '';
                                    }
                                }
                            }
                        })
                        //保存到文件
                        await ipcInvoke('save-project',{projectId:itemHistory.projectId,historyId:itemHistory.id,doc:JSON.stringify(jsonData)})
                    }
                }
            }

            //清空doc....
            clearProjectHistoryDoc();
        }
    })
}

/**
 * pdf注记文件保存到库
 */
export async function upgradePdfAnnoToLibrary(){
    ipcInvoke('list-pdf-annotation').then(async (res)=>{
        for (let i=0;i<res.length;i++){
            const item = res[i];
            const jsonData = JSON.parse(item.data);
            //保存到库
            const dbLibary:any = await getCardById(item.id);

            //不存在，或者已删除的跳过..
            if (!dbLibary || dbLibary.isDeleted == 1)continue;

            for (let j=0;j<jsonData.length;j++){
                const anno = jsonData[j];

                //base64转成图片保存
                let szFileName:any;
                let wh:any;

                const pdfAnnoLibrary = {
                    type:'pdfAnno',
                    name:dbLibary?.name,
                    id:anno.id,
                    libraryId:item.id,
                    comment:anno.comment,
                    createTime:Date.now(),
                    updateTime:Date.now(),
                    text:anno.text,
                    annoType:anno.type,
                    color:anno.color,
                }
                szFileName = anno.id + '.png';
                if (anno.image && anno.image.startsWith('data:image')){
                    await ipcInvoke('write-base64-image',{fileName:szFileName,imgBase64:anno.image});
                    wh = await getBase64ImageSize(anno.image);
                    if (wh){
                        pdfAnnoLibrary.thumbImage = 'localfile://'+szFileName;
                        pdfAnnoLibrary.width = wh?.width;
                        pdfAnnoLibrary.height = wh?.height;
                    }
                }

                await updateCard(pdfAnnoLibrary);
            }
        }
    });

    //把video标注全部取出来放到库
    highlightList('',['video']).then(async (res)=>{
        for (let i=0;i<res.length;i++){
            const item = res[i];
            const library:any = await getCardById(item.libraryId || item.id);
            if (library?.type == 'audio')continue;
            for (let j=0;j<item.data?.length;j++){
                const videoAnno = item.data[j];
                const libraryItem = {
                    ...videoAnno,
                    name:library?.name,
                    libraryId:library?.id,
                    type:'videoAnno',
                }
                await updateCard(libraryItem);
            }
        }
    })
}

/**
 * 更新project.doc的存储方式为JSON
 */
export async function upgradeProjectDocToJson(){
    getNoteDocList().then(async (res)=>{
        for (let i=0;i<res.length;i++){
            if (isString(res[i].doc)){
                res[i].doc = JSON.parse(res[i].doc);
                await updateNoteDoc(res[i]);
            }
        }
    })
}













